import { render, staticRenderFns } from "./ListOVE.vue?vue&type=template&id=1fb9f622&scoped=true&lang=pug"
import script from "./ListOVE.vue?vue&type=script&lang=js"
export * from "./ListOVE.vue?vue&type=script&lang=js"
import style0 from "./ListOVE.vue?vue&type=style&index=0&id=1fb9f622&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb9f622",
  null
  
)

export default component.exports